export const scrollToSectionWithOffset = (sectionName: string) => {
  const section = document.getElementById(sectionName);
  if (section) {
    const yOffset = -100;
    const y = section.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: "smooth" });
  }
};

export const scrollToSectionEnd = (sectionName: string) => {
  const section = document.getElementById(sectionName);
  if (section) {
    const y = section.getBoundingClientRect().bottom + window.pageYOffset;
    window.scrollTo({ top: y, behavior: "smooth" });
  }
};